// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reset-password_wrapper__5c0yX {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px;
}

.reset-password_container__LCPy0 {
  width: 100%;
  max-width: 600px;
}

.reset-password_header__SCT6Q {
  display: grid;
  grid-template-columns: 1fr min-content;
  align-items: center;
  justify-content: space-between;
}

.reset-password_content__CIdFz {
  display: grid;
  grid-template-rows: repeat(3, min-content);
  gap: 24px;
}

.reset-password_description__2IPtE {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.reset-password_button__a1EIY {
  width: fit-content;
}
`, "",{"version":3,"sources":["webpack://./src/routes/password/reset-password.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 48px;\n}\n\n.container {\n  width: 100%;\n  max-width: 600px;\n}\n\n.header {\n  display: grid;\n  grid-template-columns: 1fr min-content;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.content {\n  display: grid;\n  grid-template-rows: repeat(3, min-content);\n  gap: 24px;\n}\n\n.description {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.button {\n  width: fit-content;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `reset-password_wrapper__5c0yX`,
	"container": `reset-password_container__LCPy0`,
	"header": `reset-password_header__SCT6Q`,
	"content": `reset-password_content__CIdFz`,
	"description": `reset-password_description__2IPtE`,
	"button": `reset-password_button__a1EIY`
};
export default ___CSS_LOADER_EXPORT___;
